/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPropertyById200ResponsePolicy
 */
export interface GetPropertyById200ResponsePolicy {
    /**
     * Check-in time
     * @type {string}
     * @memberof GetPropertyById200ResponsePolicy
     */
    checkIn: string;
    /**
     * Check-out time
     * @type {string}
     * @memberof GetPropertyById200ResponsePolicy
     */
    checkOut: string;
}

/**
 * Check if a given object implements the GetPropertyById200ResponsePolicy interface.
 */
export function instanceOfGetPropertyById200ResponsePolicy(value: object): value is GetPropertyById200ResponsePolicy {
    if (!('checkIn' in value) || value['checkIn'] === undefined) return false;
    if (!('checkOut' in value) || value['checkOut'] === undefined) return false;
    return true;
}

export function GetPropertyById200ResponsePolicyFromJSON(json: any): GetPropertyById200ResponsePolicy {
    return GetPropertyById200ResponsePolicyFromJSONTyped(json, false);
}

export function GetPropertyById200ResponsePolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPropertyById200ResponsePolicy {
    if (json == null) {
        return json;
    }
    return {
        
        'checkIn': json['checkIn'],
        'checkOut': json['checkOut'],
    };
}

  export function GetPropertyById200ResponsePolicyToJSON(json: any): GetPropertyById200ResponsePolicy {
      return GetPropertyById200ResponsePolicyToJSONTyped(json, false);
  }

  export function GetPropertyById200ResponsePolicyToJSONTyped(value?: GetPropertyById200ResponsePolicy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkIn': value['checkIn'],
        'checkOut': value['checkOut'],
    };
}

